import styled from 'styled-components';

import { spaceS, spaceXL, xdlColorBackground } from '@xing-com/tokens';

import BaseButton from '../base-button';
import { BaseContentSwitcher } from '../base-content-switcher/base-content-switcher';
const frameHeightBigscreen = '68px';
const frameHeightMobile = '50px';

export const Container = styled.div`
  width: 100%;
  position: relative;

  .sticky {
    position: fixed;
    width: 100%;
    top: ${frameHeightMobile};
    background-color: ${xdlColorBackground};
    padding: ${spaceS} 0;
    z-index: 20;
    display: flex;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    overflow-x: scroll;
    scrollbar-width: none;
  }

  .sticky::-webkit-scrollbar {
    display: none;
  }

  .stickyWebview {
    top: 0;
  }

  .inner {
    display: flex;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    overflow-x: scroll;
    scrollbar-width: none;
    z-index: 20;
    padding: ${spaceXL} 0;
  }
  .inner::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 740px) {
    .sticky {
      top: ${frameHeightBigscreen};
    }

    .inner {
      padding: 0;
    }
  }
`;

export const ContentSwitcher = styled(BaseContentSwitcher)`
  a {
    text-decoration: none !important;
  }
`;

export const ProjobsButton = styled(BaseButton)`
  white-space: nowrap;
`;

export const ProjobsButtonWrapper = styled.div`
  position: relative;

  @media (min-width: 740px) {
    position: absolute;
    top: 0;
    right: 0;
  }
`;
